module.exports = __webpack_public_path__ + "static/img/index-banner.cba409f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/developerConference/index-banner.jpg
// module id = YIhJ
// module chunks = 86